import { createActions, createReducer } from "reduxsauce"
import * as Immutable from "seamless-immutable"
import { generateQuickGuid } from "../../helpers/utility"
// import * as R from 'ramda';

/* ------------- Types and Action Creators ------------- */
// const tag = '[SAGA_BOOKING_REDUX]'; // eslint-disable-line

const functionDefinitions = {
  /*---------- getInitialBooking --------*/
  requestGetInitialBooking: [],
  getInitialBookingSuccess: ["getInitialBookingResponse"],
  getInitialBookingFailure: ["getInitialBookingError"],

  /*---------- getInitialBookingDetail --------*/
  requestGetInitialBookingDetail: ["bookingDetail"],
  getInitialBookingDetailSuccess: ["getInitialBookingDetailResponse"],
  getInitialBookingDetailFailure: ["getInitialBookingDetailError"],

  /*---------- createBooking --------*/
  requestCreateBooking: [
    "bookingTrip",
    "routeItems",
    "selectedBusTypes",
    "userId"
  ],
  createBookingSuccess: ["createBookingResponse"],
  createBookingFailure: ["createBookingError"],

  /*---------- updateBooking --------*/
  requestUpdateBooking: [
    "bookingTrip",
    "routeItems",
    "selectedBusTypes",
    "userId"
  ],
  updateBookingSuccess: ["updateBookingResponse"],
  updateBookingFailure: ["updateBookingError"],

  /*---------- getBookingDetail --------*/
  requestGetBookingDetail: ["id", "userId"],
  getBookingDetailSuccess: ["getBookingDetailResponse"],
  getBookingDetailFailure: ["getBookingDetailError"],

  /*---------- bookingNextStepClicked --------*/
  bookingNextStepClicked: [],

  /*---------- getQuotationDetail --------*/
  requestGetQuotationDetail: ["id"],
  getQuotationDetailSuccess: ["getQuotationDetailResponse"],
  getQuotationDetailFailure: ["getQuotationDetailError"],

  /*---------- getPaymentDetail --------*/
  requestGetPaymentDetail: ["id", "userId"],
  getPaymentDetailSuccess: ["getPaymentDetailResponse"],
  getPaymentDetailFailure: ["getPaymentDetailError"],

  /*---------- getHisobusMybooking --------*/
  requestGetHisobusMybooking: ["userId"],
  getHisobusMybookingSuccess: ["getHisobusMybookingResponse"],
  getHisobusMybookingFailure: ["getHisobusMybookingError"],

  /*---------- sendQuotation --------*/
  requestSendQuotation: ["userId", "id"],
  sendQuotationSuccess: ["sendQuotationResponse"],
  sendQuotationFailure: ["sendQuotationError"],

  /*---------- updateMyBookingTransaction --------*/
  requestUpdateMyBookingTransaction: ["bookingTransaction"],
  updateMyBookingTransactionSuccess: ["updateMyBookingTransactionResponse"],
  updateMyBookingTransactionFailure: ["updateMyBookingTransactionError"],

  /*---------- getPriceCompare --------*/
  requestGetPriceCompare: ["bookingDetail"],
  getPriceCompareSuccess: ["getPriceCompareResponse"],
  getPriceCompareFailure: ["getPriceCompareError"],

  /*---------- createCarBooking --------*/
  requestCreateCarBooking: ["booking"],
  createCarBookingSuccess: ["createCarBookingResponse"],
  createCarBookingFailure: ["createCarBookingError"],

  /*---------- checkBookingPrice --------*/
  requestCheckBookingPrice: ["bookingId", "userId"],
  checkBookingPriceSuccess: ["checkBookingPriceResponse"],
  checkBookingPriceFailure: ["checkBookingPriceError"],

  /*---------- getPromotionByPromoCode --------*/

  requestGetPromotionByPromoCode: ["code"],
  getPromotionByPromoCodeSuccess: ["getPromotionByPromoCodeResponse"],
  getPromotionByPromoCodeFailure: ["getPromotionByPromoCodeError"],

  /*---------- getTripObjects --------*/

  requestGetTripObjects: [],
  getTripObjectsSuccess: ["getTripObjectsResponse"],
  getTripObjectsFailure: ["getTripObjectsError"]
}

const { Types, Creators } = createActions(functionDefinitions)

export const SagaBookingTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const SagBookingInitState = {
  refId: generateQuickGuid()
}

export const INITIAL_STATE = Immutable(SagBookingInitState)

/* ------------- Reducers ------------- */

/*---------- getInitialBooking --------*/
export const requestGetInitialBooking = state => {
  return state.merge({
    getInitialBookingFetching: true,
    getInitialBookingResponse: null,
    getInitialBookingError: null,
    getPromotionByPromoCodeResponse: null
  })
}
export const getInitialBookingSuccess = (state, action) => {
  return state.merge({
    getInitialBookingFetching: false,
    getInitialBookingResponse: action.getInitialBookingResponse
  })
}
export const getInitialBookingFailure = (state, action) => {
  return state.merge({
    getInitialBookingFetching: false,
    getInitialBookingError: action.getInitialBookingError
  })
}

/*---------- getInitialBookingDetail --------*/
export const requestGetInitialBookingDetail = (state, action) => {
  return state.merge({
    getInitialBookingDetailFetching: true,
    getInitialBookingDetailResponse: null,
    getInitialBookingDetailError: null,
    bookingDetail: action.bookingDetail,
    getPromotionByPromoCodeResponse: null
  })
}
export const getInitialBookingDetailSuccess = (state, action) => {
  return state.merge({
    getInitialBookingDetailFetching: false,
    getInitialBookingDetailResponse: action.getInitialBookingDetailResponse
  })
}
export const getInitialBookingDetailFailure = (state, action) => {
  return state.merge({
    getInitialBookingDetailFetching: false,
    getInitialBookingDetailError: action.getInitialBookingDetailError
  })
}

/*---------- createBooking --------*/
export const requestCreateBooking = (state, action) => {
  return state.merge({
    bookingFetching: true,
    bookingTrip: action.bookingTrip,
    routeItems: action.routeItems,
    selectedBusTypes: action.selectedBusTypes,
    userId: action.userId,
    bookingResponse: null,
    bookingError: null
  })
}
export const createBookingSuccess = (state, action) => {
  return state.merge({
    bookingFetching: false,
    bookingResponse: action.createBookingResponse
  })
}
export const createBookingFailure = (state, action) => {
  return state.merge({
    bookingFetching: false,
    bookingError: action.createBookingError
  })
}

/*---------- updateBooking --------*/

export const requestUpdateBooking = (state, action) => {
  return state.merge({
    bookingFetching: true,
    bookingTrip: action.bookingTrip,
    routeItems: action.routeItems,
    selectedBusTypes: action.selectedBusTypes,
    userId: action.userId,
    bookingError: null,
    bookingResponse: null
  })
}
export const updateBookingSuccess = (state, action) => {
  return state.merge({
    bookingFetching: false,
    bookingResponse: action.updateBookingResponse
  })
}
export const updateBookingFailure = (state, action) => {
  return state.merge({
    bookingFetching: false,
    bookingError: action.updateBookingError
  })
}

/*---------- getBookingDetail --------*/
export const requestGetBookingDetail = (state, action) => {
  return state.merge({
    bookingFetching: true,
    id: action.id,
    userId: action.userId,
    getBookingDetailResponse: null,
    bookingError: null
  })
}
export const getBookingDetailSuccess = (state, action) => {
  return state.merge({
    bookingFetching: false,
    getBookingDetailResponse: action.getBookingDetailResponse
  })
}
export const getBookingDetailFailure = (state, action) => {
  return state.merge({
    bookingFetching: false,
    bookingError: action.getBookingDetailError
  })
}

/*---------- bookingNextStepClicked --------*/
export const bookingNextStepClicked = state => {
  return state.merge({
    bookingResponse: null
  })
}

/*---------- getQuotationDetail --------*/
export const requestGetQuotationDetail = (state, action) => {
  return state.merge({
    getQuotationDetailFetching: true,
    id: action.id,
    getQuotationDetailResponse: null,
    getQuotationDetailError: null
  })
}
export const getQuotationDetailSuccess = (state, action) => {
  return state.merge({
    getQuotationDetailFetching: false,
    getQuotationDetailResponse: action.getQuotationDetailResponse
  })
}
export const getQuotationDetailFailure = (state, action) => {
  return state.merge({
    getQuotationDetailFetching: false,
    getQuotationDetailError: action.getQuotationDetailError
  })
}

/*---------- getPaymentDetail --------*/
export const requestGetPaymentDetail = (state, action) => {
  return state.merge({
    getPaymentDetailFetching: true,
    id: action.id,
    userId: action.userId,
    getPaymentDetailResponse: null,
    getPaymentDetailError: null
  })
}
export const getPaymentDetailSuccess = (state, action) => {
  return state.merge({
    getPaymentDetailFetching: false,
    getPaymentDetailResponse: action.getPaymentDetailResponse
  })
}
export const getPaymentDetailFailure = (state, action) => {
  return state.merge({
    getPaymentDetailFetching: false,
    getPaymentDetailError: action.getPaymentDetailError
  })
}

/*---------- getHisobusMybooking --------*/
export const requestGetHisobusMybooking = (state, action) => {
  return state.merge({
    getHisobusMybookingFetching: true,
    userId: action.userId
  })
}
export const getHisobusMybookingSuccess = (state, action) => {
  return state.merge({
    getHisobusMybookingFetching: false,
    getHisobusMybookingResponse: action.getHisobusMybookingResponse,
    getHisobusMybookingError: null
  })
}
export const getHisobusMybookingFailure = (state, action) => {
  return state.merge({
    getHisobusMybookingFetching: false,
    getHisobusMybookingError: action.getHisobusMybookingError
  })
}

/*---------- sendQuotation --------*/
export const requestSendQuotation = (state, action) => {
  return state.merge({
    sendQuotationFetching: true,
    userId: action.userId,
    id: action.id
  })
}
export const sendQuotationSuccess = (state, action) => {
  return state.merge({
    sendQuotationFetching: false,
    sendQuotationResponse: action.sendQuotationResponse,
    sendQuotationError: null
  })
}
export const sendQuotationFailure = (state, action) => {
  return state.merge({
    sendQuotationFetching: false,
    sendQuotationError: action.sendQuotationError
  })
}

/*---------- updateMyBookingTransaction --------*/
export const requestUpdateMyBookingTransaction = (state, action) => {
  return state.merge({
    updateMyBookingTransactionFetching: true,
    bookingTransaction: action.bookingTransaction
  })
}
export const updateMyBookingTransactionSuccess = (state, action) => {
  return state.merge({
    updateMyBookingTransactionFetching: false,
    updateMyBookingTransactionResponse:
      action.updateMyBookingTransactionResponse,
    getHisobusMybookingResponse: action.updateMyBookingTransactionResponse,
    updateMyBookingTransactionError: null
  })
}
export const updateMyBookingTransactionFailure = (state, action) => {
  return state.merge({
    updateMyBookingTransactionFetching: false,
    updateMyBookingTransactionError: action.updateMyBookingTransactionError
  })
}

/*---------- getPriceCompare --------*/
export const requestGetPriceCompare = (state, action) => {
  return state.merge({
    getPriceCompareFetching: true,
    bookingDetail: action.bookingDetail
  })
}
export const getPriceCompareSuccess = (state, action) => {
  return state.merge({
    getPriceCompareFetching: false,
    getPriceCompareResponse: action.getPriceCompareResponse,
    getPriceCompareError: null
  })
}
export const getPriceCompareFailure = (state, action) => {
  return state.merge({
    getPriceCompareFetching: false,
    getPriceCompareError: action.getPriceCompareError
  })
}

/*---------- createCarBooking --------*/
export const requestCreateCarBooking = (state: Immutable, action) => {
  return state.merge({
    createCarBookingFetching: true,
    booking: action.booking
  })
}
export const createCarBookingSuccess = (state: Immutable, action) => {
  return state.merge({
    createCarBookingFetching: false,
    createCarBookingResponse: action.createCarBookingResponse,
    createCarBookingError: null
  })
}
export const createCarBookingFailure = (state: Immutable, action) => {
  return state.merge({
    createCarBookingFetching: false,
    createCarBookingError: action.createCarBookingError
  })
}

/*---------- checkBookingPrice --------*/
export const requestCheckBookingPrice = (state: Immutable, action) => {
  return state.merge({
    checkBookingPriceFetching: true,
    bookingId: action.bookingId,
    userId: action.userId
  })
}
export const checkBookingPriceSuccess = (state: Immutable, action) => {
  return state.merge({
    checkBookingPriceFetching: false,
    checkBookingPriceResponse: action.checkBookingPriceResponse,
    checkBookingPriceError: null
  })
}
export const checkBookingPriceFailure = (state: Immutable, action) => {
  return state.merge({
    checkBookingPriceFetching: false,
    checkBookingPriceError: action.checkBookingPriceError
  })
}

/*---------- getPromotionByPromoCode --------*/

export const requestGetPromotionByPromoCode = (state: Immutable, action) => {
  return state.merge({
    getPromotionByPromoCodeFetching: true,
    code: action.code
  })
}
export const getPromotionByPromoCodeSuccess = (state: Immutable, action) => {
  return state.merge({
    getPromotionByPromoCodeFetching: false,
    getPromotionByPromoCodeResponse: action.getPromotionByPromoCodeResponse
  })
}
export const getPromotionByPromoCodeFailure = (state: Immutable, action) => {
  return state.merge({
    getPromotionByPromoCodeFetching: false,
    getPromotionByPromoCodeError: action.getPromotionByPromoCodeError
  })
}

/*---------- getTripObjects --------*/

export const requestGetTripObjects = (state: Immutable) => {
  return state.merge({
    getTripObjectsFetching: true
  })
}
export const getTripObjectsSuccess = (state: Immutable, action) => {
  return state.merge({
    getTripObjectsFetching: false,
    getTripObjectsResponse: action.getTripObjectsResponse,
    getTripObjectsError: null
  })
}
export const getTripObjectsFailure = (state: Immutable, action) => {
  return state.merge({
    getTripObjectsFetching: false,
    getTripObjectsError: action.getTripObjectsError
  })
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  /*---------- getInitialBooking --------*/
  [Types.REQUEST_GET_INITIAL_BOOKING]: requestGetInitialBooking,
  [Types.GET_INITIAL_BOOKING_SUCCESS]: getInitialBookingSuccess,
  [Types.GET_INITIAL_BOOKING_FAILURE]: getInitialBookingFailure,

  /*---------- getInitialBookingDetail --------*/
  [Types.REQUEST_GET_INITIAL_BOOKING_DETAIL]: requestGetInitialBookingDetail,
  [Types.GET_INITIAL_BOOKING_DETAIL_SUCCESS]: getInitialBookingDetailSuccess,
  [Types.GET_INITIAL_BOOKING_DETAIL_FAILURE]: getInitialBookingDetailFailure,

  /*---------- createBooking --------*/
  [Types.REQUEST_CREATE_BOOKING]: requestCreateBooking,
  [Types.CREATE_BOOKING_SUCCESS]: createBookingSuccess,
  [Types.CREATE_BOOKING_FAILURE]: createBookingFailure,

  /*---------- updateBooking --------*/
  [Types.REQUEST_UPDATE_BOOKING]: requestUpdateBooking,
  [Types.UPDATE_BOOKING_SUCCESS]: updateBookingSuccess,
  [Types.UPDATE_BOOKING_FAILURE]: updateBookingFailure,

  /*---------- getBookingDetail --------*/
  [Types.REQUEST_GET_BOOKING_DETAIL]: requestGetBookingDetail,
  [Types.GET_BOOKING_DETAIL_SUCCESS]: getBookingDetailSuccess,
  [Types.GET_BOOKING_DETAIL_FAILURE]: getBookingDetailFailure,

  /*---------- bookingNextStepClicked --------*/
  [Types.BOOKING_NEXT_STEP_CLICKED]: bookingNextStepClicked,

  /*---------- getQuotationDetail --------*/
  [Types.REQUEST_GET_QUOTATION_DETAIL]: requestGetQuotationDetail,
  [Types.GET_QUOTATION_DETAIL_SUCCESS]: getQuotationDetailSuccess,
  [Types.GET_QUOTATION_DETAIL_FAILURE]: getQuotationDetailFailure,

  /*---------- getPaymentDetail --------*/
  [Types.REQUEST_GET_PAYMENT_DETAIL]: requestGetPaymentDetail,
  [Types.GET_PAYMENT_DETAIL_SUCCESS]: getPaymentDetailSuccess,
  [Types.GET_PAYMENT_DETAIL_FAILURE]: getPaymentDetailFailure,

  /*---------- getHisobusMybooking --------*/
  [Types.REQUEST_GET_HISOBUS_MYBOOKING]: requestGetHisobusMybooking,
  [Types.GET_HISOBUS_MYBOOKING_SUCCESS]: getHisobusMybookingSuccess,
  [Types.GET_HISOBUS_MYBOOKING_FAILURE]: getHisobusMybookingFailure,

  /*---------- sendQuotation --------*/
  [Types.REQUEST_SEND_QUOTATION]: requestSendQuotation,
  [Types.SEND_QUOTATION_SUCCESS]: sendQuotationSuccess,
  [Types.SEND_QUOTATION_FAILURE]: sendQuotationFailure,

  /*---------- updateMyBookingTransaction --------*/
  [Types.REQUEST_UPDATE_MY_BOOKING_TRANSACTION]: requestUpdateMyBookingTransaction,
  [Types.UPDATE_MY_BOOKING_TRANSACTION_SUCCESS]: updateMyBookingTransactionSuccess,
  [Types.UPDATE_MY_BOOKING_TRANSACTION_FAILURE]: updateMyBookingTransactionFailure,

  /*---------- getPriceCompare --------*/
  [Types.REQUEST_GET_PRICE_COMPARE]: requestGetPriceCompare,
  [Types.GET_PRICE_COMPARE_SUCCESS]: getPriceCompareSuccess,
  [Types.GET_PRICE_COMPARE_FAILURE]: getPriceCompareFailure,

  /*---------- createCarBooking --------*/
  [Types.REQUEST_CREATE_CAR_BOOKING]: requestCreateCarBooking,
  [Types.CREATE_CAR_BOOKING_SUCCESS]: createCarBookingSuccess,
  [Types.CREATE_CAR_BOOKING_FAILURE]: createCarBookingFailure,

  /*---------- checkBookingPrice --------*/
  [Types.REQUEST_CHECK_BOOKING_PRICE]: requestCheckBookingPrice,
  [Types.CHECK_BOOKING_PRICE_SUCCESS]: checkBookingPriceSuccess,
  [Types.CHECK_BOOKING_PRICE_FAILURE]: checkBookingPriceFailure,

  /*---------- getPromotionByPromoCode --------*/

  [Types.REQUEST_GET_PROMOTION_BY_PROMO_CODE]: requestGetPromotionByPromoCode,
  [Types.GET_PROMOTION_BY_PROMO_CODE_SUCCESS]: getPromotionByPromoCodeSuccess,
  [Types.GET_PROMOTION_BY_PROMO_CODE_FAILURE]: getPromotionByPromoCodeFailure,

  /*---------- getTripObjects --------*/

  [Types.REQUEST_GET_TRIP_OBJECTS]: requestGetTripObjects,
  [Types.GET_TRIP_OBJECTS_SUCCESS]: getTripObjectsSuccess,
  [Types.GET_TRIP_OBJECTS_FAILURE]: getTripObjectsFailure
})



// WEBPACK FOOTER //
// ./src/redux/sagaBooking/sagaBookingRedux.ts